import { render, staticRenderFns } from "./ownerTaskAudit.vue?vue&type=template&id=1268f1f9&scoped=true"
import script from "./ownerTaskAudit.vue?vue&type=script&lang=js"
export * from "./ownerTaskAudit.vue?vue&type=script&lang=js"
import style0 from "./ownerTaskAudit.vue?vue&type=style&index=0&id=1268f1f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1268f1f9",
  null
  
)

export default component.exports